import { getStorage, ref, deleteObject } from "firebase/storage";  // Import Firebase Storage functions

async function deleteImage(imageUrl) {
    const storage = getStorage();
    const imageRef = ref(storage, imageUrl);  

    try {
        await deleteObject(imageRef);
    } 
    catch (error) {
        console.error("Error deleting image:", error);
    }
}

export default deleteImage;